<template>
	<div>
		<DeleteDialog
			:dialog.sync="showDeleteDialog"
			@confirm="
				showDeleteDialog = false;
				deleteUserConfirm();
			" />
		<v-data-table
			:headers="headers"
			:items="itemsConsumable"
			:loading="loading"
			:search="appBarSearch"
			:height="pageHeight(176)"
			dense
			:no-data-text="$t('no-data-available')"
			:loading-text="$t('loading')"
			:items-per-page="-1"
			sort-by="name">
			<template #item="{ item, index }">
				<tr class="text-left" :class="{ 'odd-row': index % 2 }">
					<td>{{ item.name }}</td>
					<td>{{ item.manufacturer }}</td>
					<td>{{ item.category }}</td>
					<td>{{ item.unitOfMeasure }}</td>
					<td>{{ item.internalProductCode }}</td>
					<td>{{ item.minStockThreshold }}</td>
					<td class="truncate-text" style="max-width: 25vw">{{ item.notes }}</td>
					<td class="text-right">
						<v-tooltip color="primary" top>
							<template #activator="{ on }">
								<v-icon v-on="on" color="primary" @click="assignConsumable(item)">mdi-plus-circle</v-icon>
							</template>
							<span>{{ $t('assign-consumable') }}</span>
						</v-tooltip>
						<v-icon color="primary" @click="synchronizeDrawer(item)">mdi-pencil</v-icon>
						<v-icon color="primary" @click="enableDeleteDialog(item)">mdi-delete</v-icon>
					</td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DeleteDialog from '@/views/dialogs/DeleteDialog.vue';
import { showSuccessAlert } from '../../../utils/utilities';

export default {
	name: 'InventoryConsumerCatalog.vue',
	components: {
		DeleteDialog,
	},
	data () {
		return {
			itemsConsumable: [],
			loading: false,
			showDeleteDialog: false,
			itemToDelete: null,
		};
	},
	methods: {
		...mapActions({
			getConsumableCatalogs: 'inventoryConsumableCatalogs/getConsumableCatalogs',
			getConsumableCatalogById: 'inventoryConsumableCatalogs/getConsumableCatalogById',
			deleteConsumableCatalogs: 'inventoryConsumableCatalogs/deleteConsumableCatalogs',
		}),
		async synchronizeDrawer (item) {
			await this.getConsumableCatalogById(item.id);
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
				updateDrawer: true,
				page2: 'consumable catalog',
			});
		},
		async assignConsumable (item) {
			await this.getConsumableCatalogById(item.id);
			const parameters = {
				detailsDrawer: true,
				page: 'inventory consumables',
			};
			this.$store.commit('SET_DETAILS_DRAWER', parameters);
		},
		async getConsumableCatalogItems () {
			const result = await this.getConsumableCatalogs();
			this.itemsConsumable = result;
		},
		async deleteUserConfirm () {
			const result = await this.deleteConsumableCatalogs(this.itemToDelete.id);
			if (result.resFlag) {
				showSuccessAlert(result.msg);
				this.showDeleteDialog = false;
				this.getConsumableCatalogItems();
			}
		},
		enableDeleteDialog (item) {
			this.itemToDelete = item;
			this.showDeleteDialog = true;
		},
	},
	computed: {
		...mapGetters({
			pageHeight: 'pageHeight',
			appBarSearch: 'filterbar/getSearch',
		}),
		headers () {
			return [
				{ text: this.$t('name'), value: 'name' },
				{ text: this.$t('manufacturer'), value: 'manufacturer' },
				{ text: this.$t('category'), value: 'category' },
				{ text: this.$t('unit-of-measure'), value: 'unitOfMeasure' },
				{ text: this.$t('internal-product-code'), value: 'internalProductCode' },
				{ text: this.$t('min-stock-threshold'), value: 'minStockThreshold' },
				{ text: this.$t('notes'), value: 'notes' },
				{ text: this.$t('actions'), value: 'actions', align: 'end', sortable: false },
			];
		},
		detailsDrawer () {
			return this.$store.state.detailsDrawer;
		},
		updateDrawer () {
			return this.$store.state.updateDrawer;
		},
	},
	async mounted () {
		this.getConsumableCatalogItems();
	},
	watch: {
		detailsDrawer (val) {
			if (!val) {
				this.getConsumableCatalogItems();
			}
		},
		updateDrawer (val) {
			if (!val) {
				this.getConsumableCatalogItems();
			}
		},
	},
};
</script>
